import { defineComponent, computed } from "vue";
import Avatar from "../../common/Avatar.vue.mjs";
import { useBasicStore } from "../../../stores/basic.mjs";
import { useRoomStore } from "../../../stores/room.mjs";
import { storeToRefs } from "pinia";
import SvgIcon from "../../common/base/SvgIcon.vue.mjs";
import VideoOpenIcon from "../../common/icons/VideoOpenIcon.vue.mjs";
import VideoCloseIcon from "../../common/icons/VideoCloseIcon.vue.mjs";
import AudioOpenIcon from "../../common/icons/AudioOpenIcon.vue.mjs";
import AudioCloseIcon from "../../common/icons/AudioCloseIcon.vue.mjs";
import ScreenOpenIcon from "../../common/icons/ScreenOpenIcon.vue.mjs";
import ApplyActiveIcon from "../../common/icons/ApplyActiveIcon.vue.mjs";
import MemberInvite from "../MemberInvite/MemberInvite.vue.mjs";
import { useI18n } from "../../../locales/index.mjs";
import { isMobile } from "../../../utils/environment.mjs";
import UserIcon from "../../common/icons/UserIcon.vue.mjs";
import { TUIRole } from "@tencentcloud/tuiroom-engine-js";
import "../../../services/main.mjs";
import { roomService } from "../../../services/roomService.mjs";
import "mitt";
import "../../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MemberInfo",
  props: {
    userInfo: null,
    showStateIcon: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const { t } = useI18n();
    const basicStore = useBasicStore();
    const roomStore = useRoomStore();
    const { isMaster, isSpeakAfterTakingSeatMode } = storeToRefs(roomStore);
    const isMe = computed(() => basicStore.userId === props.userInfo.userId);
    const isTargetUserRoomOwner = computed(
      () => props.userInfo.userRole === TUIRole.kRoomOwner
    );
    const isTargetUserAdmin = computed(
      () => props.userInfo.userRole === TUIRole.kAdministrator
    );
    const extraInfo = computed(() => {
      if (isMaster.value && isMe.value) {
        return `${t("Host")}, ${t("Me")}`;
      }
      if (isTargetUserRoomOwner.value) {
        return t("Host");
      }
      if (isTargetUserAdmin.value && isMe.value) {
        return `${t("Admin")}, ${t("Me")}`;
      }
      if (isTargetUserAdmin.value) {
        return t("Admin");
      }
      if (isMe.value) {
        return t("Me");
      }
      return "";
    });
    const isAudienceRole = computed(
      () => isSpeakAfterTakingSeatMode.value && !props.userInfo.onSeat
    );
    const iconList = computed(() => {
      const list = [];
      if (props.userInfo.hasScreenStream) {
        list.push({ icon: ScreenOpenIcon });
      }
      if (!isAudienceRole.value) {
        list.push({
          icon: props.userInfo.hasAudioStream ? AudioOpenIcon : AudioCloseIcon
        });
        list.push({
          icon: props.userInfo.hasVideoStream ? VideoOpenIcon : VideoCloseIcon
        });
      }
      if (isAudienceRole.value && !props.userInfo.isUserApplyingToAnchor) {
        list.push({ icon: AudioCloseIcon, disable: true });
        list.push({ icon: VideoCloseIcon, disable: true });
      }
      if (isAudienceRole.value && props.userInfo.isUserApplyingToAnchor) {
        list.push({ icon: ApplyActiveIcon, size: 20 });
      }
      return list;
    });
    return { __sfc: true, t, props, basicStore, roomStore, isMaster, isSpeakAfterTakingSeatMode, isMe, isTargetUserRoomOwner, isTargetUserAdmin, extraInfo, isAudienceRole, iconList, Avatar, SvgIcon, MemberInvite, isMobile, UserIcon, roomService };
  }
});
export {
  _sfc_main as default
};
